import './App.css';
import MainContent from './components/MainContent';

function App() {
  return (
    <div className="app">
      <div className="history__section">
        <div className="history__header">History</div>
        <div className="history__content">
        </div>
      </div>
      <div className="main__section">
        <div className="main__header">Spanish Verb Conjugator</div>
        <MainContent />
      </div>
    </div>
  );
}

export default App;
